import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import { SNACKBAR_MODAL_TYPE, SnackbarCTA } from '@marriott/mi-web-ui-kit';
import { WISHLIST_MODAL_TYPE } from '../utils/constants';

export interface WishlistSnackbarConfig {
  modalType: SNACKBAR_MODAL_TYPE | null;
  message: string;
  ctas: SnackbarCTA[];
}

export interface WishlistModalState {
  modalType: WISHLIST_MODAL_TYPE | null;
  wishlistId: string | null;

  snackbar: WishlistSnackbarConfig;

  setModalType: (type: WISHLIST_MODAL_TYPE | null) => void;
  setWishlistId: (id: string | null) => void;
  setSnackbar: (modalType: SNACKBAR_MODAL_TYPE, message: string, ctas?: SnackbarCTA[]) => void;
  clearSnackbar: () => void;
}

const defaultSnackbar: WishlistSnackbarConfig = {
  modalType: null,
  message: '',
  ctas: [],
};

const initialState = {
  modalType: null,
  wishlistId: null,
  snackbar: defaultSnackbar,
};

const wishlistModalStore: StateCreator<WishlistModalState> = set => ({
  ...initialState,

  setModalType: type =>
    set(() => ({
      modalType: type,
    })),

  setWishlistId: id =>
    set(() => ({
      wishlistId: id,
    })),

  setSnackbar: (modalType, message, ctas = []) =>
    set(() => ({
      snackbar: {
        modalType,
        message,
        ctas,
      },
    })),

  clearSnackbar: () =>
    set(() => ({
      snackbar: defaultSnackbar,
    })),
});

export const useWishlistModalStore = createAppStore(wishlistModalStore, {
  usePersistentStore: false,
});
